<!--
    `loading="lazy"` não entra: são 28 arquivos minúsculos e no máximo uma dúzia por página, e o
    carregamento tardio faria a bandeira aparecer depois da linha já desenhada — um pulo visível na
    varredura da tabela.
-->
<span class="bandeira-uf">
    @if (bandeira(); as arquivo) {
        <img class="bandeira-uf-imagem" [src]="arquivo" alt="" aria-hidden="true" decoding="async" />
    }
    <span class="bandeira-uf-sigla">{{ rotulo() }}</span>
</span>
